<script setup lang="ts">
import data from '@/common/data/about/data';
import StandardPage from '@/content-types/standard-page/StandardPage.vue';
import PageContent from '@/components/page-content/PageContent.vue';
import { useSeoMeta } from '#app';

useSeoMeta({
  title: 'About | Open Methane',
  ogTitle: 'About | Open Methane',
  description: 'Open Methane is a free, open source platform for detecting, measuring and locating Australia\'s methane emissions.',
  ogDescription: 'Open Methane is a free, open source platform for detecting, measuring and locating Australia\'s methane emissions.',
});
</script>

<template>
  <StandardPage title="About">
    <PageContent :page-data="data" hide-mobile-page-nav />
  </StandardPage>
</template>
